export default [
  {
    label: 'Lunes',
    value: 'lunes'
  },
  {
    label: 'Martes',
    value: 'martes'
  },
  {
    label: 'Miércoles',
    value: 'miercoles'
  },
  {
    label: 'Jueves',
    value: 'jueves'
  },
  {
    label: 'Viernes',
    value: 'viernes'
  },
  {
    label: 'Sábado',
    value: 'sabado'
  },
  {
    label: 'Domingo',
    value: 'domingo'
  }
]
